<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Work_Orders_Title' | translateWF: 'Work Orders' }}</h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-speeddial [model]="orderMenuitems()" direction="left" [transitionDelay]="80">
              <ng-template #button let-toggleCallback="toggleCallback">
                <p-button (click)="toggleCallback($event)" [label]="'Work_Orders_Create_Order_Button' | translateWF: 'Create Order'" icon="pi pi-plus" iconPos="left"></p-button>
              </ng-template>
              <ng-template #item let-item let-toggleCallback="toggleCallback">
                <p-button severity="secondary" (click)="toggleCallback($event, item)" [label]="item.label | translateWF: item.label"></p-button>
              </ng-template>
            </p-speeddial>
          }
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'Work_Orders_Title' | translateWF: 'Work Orders'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="listWorkOrders()" [lazy]="true" [sortField]="sortField()" [sortOrder]="sortOrder()" selectionMode="single" (onSort)="onSort($event)">
            <ng-template pTemplate="header">
              <tr class="cs-datatable-header-dark">
                @if (canEdit()) {
                  <th style="width: 60px"></th>
                }
                <th pSortableColumn="orderNumber">
                  {{ 'Work_Orders_Table_Number' | translateWF: 'Number' }}
                  <p-sortIcon field="orderNumber"></p-sortIcon>
                </th>
                <th>{{ 'Work_Orders_Table_Status' | translateWF: 'Status' }}</th>
                <th>{{ 'Work_Orders_Table_Client' | translateWF: 'Client' }}</th>
                <th>{{ 'Work_Orders_Table_Brand' | translateWF: 'Brand' }}</th>
                <th>{{ 'Work_Orders_Table_Client_Product_Orders' | translateWF: 'Client Product Order(s)' }}</th>
                <th>{{ 'Work_Orders_Table_Order_Type' | translateWF: 'Order Type' }}</th>
                <th></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-index="rowIndex">
              @let order = getRowData(rowData);
              <tr class="cursor-pointer" (click)="redirectToDetails(order.id)">
                @if (canEdit()) {
                  <td (click)="copyWorkOrder(order.id, $event)" style="width: 60px">
                    <p-button severity="secondary" icon="pi pi-copy" [pTooltip]="'Work_Orders_Copy_Button' | translateWF: 'Copy Work Order'"></p-button>
                  </td>
                }
                <td>
                  <a>{{ order.orderNumber }}</a>
                </td>
                <td>{{ orderStatusesEnums()[order.status] }}</td>
                <td>{{ order.customer.name }}</td>
                <td>{{ order.brand.name }}</td>
                <td>{{ getCustomerProductOrder(order) }}</td>
                <td>{{ orderTypesEnums()[order.orderType] }}</td>
                <td class="w-[72px] col">
                  @if (order.orderType == 1) {
                    <p-button
                      severity="secondary"
                      icon="pi pi-file-plus"
                      class="mb-2"
                      (onClick)="createShortFall(order.id, $event)"
                      [pTooltip]="'Work_Orders_Create_ShortFall_Button' | translateWF: 'Create Short Fall'"
                    />
                  }
                  <p-button
                    severity="secondary"
                    icon="pi pi-print"
                    (onClick)="printReportPdf(order.id, $event)"
                    [pTooltip]="'Work_Orders_Print_Button' | translateWF: 'Print Report'"
                  />
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7">
                  {{ 'Work_Orders_Not_Found' | translateWF: 'No work orders found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[15, 25, 50, 100]"
            dropdownAppendTo="body"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
